<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <h2>Preview Recipients</h2>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <p class="subtitle">
      Customers who will receive this automation: <strong>{{ totalCount }}</strong>
    </p>
  </div>

  <div class="dialog-body">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="!loading && customers.length === 0" class="empty-state">
      <mat-icon class="empty-icon">people_outline</mat-icon>
      <p>No customers match the automation filters</p>
    </div>

    <div *ngIf="!loading && customers.length > 0" class="table-container">
      <ngx-datatable
        class="material"
        [headerHeight]="45"
        [rows]="customers"
        [scrollbarV]="false"
        [scrollbarH]="true"
        [footerHeight]="50"
        [columnMode]="'force'"
        [rowHeight]="60"
        [externalPaging]="true"
        [count]="totalCount"
        [offset]="pageIndex"
        [limit]="pageSize"
        (page)="pageEvent($event)"
      >
        <ngx-datatable-column name="Name" [resizeable]="false" [width]="200">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ getCustomerName(row) }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Email" [resizeable]="false" [width]="250">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ getCustomerEmail(row) }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Stamps" [resizeable]="false" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.totalStamps || 0 }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Rewards" [resizeable]="false" [width]="100">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.totalRewards || 0 }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</div>

